import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useProp103Features } from './useProp103Features';

export const useCoverageInformation = () => {
  const isProp103 = useProp103Features();
  const {
    data,
    petQuoteSelected,
  } = useSelector(({ quoting }) => (quoting), shallowEqual);

  const sortByOrder = (items) => [...items].sort((a, b) => a.Order - b.Order);

  const coverageInformation = useMemo(() => {
    if (isProp103 && data) {
      const petQuote = data.ebPetQuoteResponseList
        .find((item) => item.petQuoteId === petQuoteSelected);
      if (!petQuote) {
        return {
          notCovered: [],
          whatsCovered: [],
        };
      }

      const { PlanType } = petQuote;
      const coverageByPlanType = data.CoverageInformation.WhatsCovered.filter(
        (coverage) => coverage.PlanTypeId === PlanType,
      ) || [];

      const notCoveredByPlanType = data.CoverageInformation.NotCovered.filter(
        (coverage) => coverage.PlanTypeId === PlanType,
      ) || [];

      return {
        notCovered: sortByOrder(notCoveredByPlanType),
        whatsCovered: coverageByPlanType,
      };
    }

    return {
      notCovered: sortByOrder(data?.CoverageInformation?.NotCovered || []),
      whatsCovered: data?.CoverageInformation?.WhatsCovered || [],
    };
  }, [data, isProp103, petQuoteSelected]);

  return coverageInformation;
};
